<template>
    <GChart type="ColumnChart" :data="chartData" />
  </template>
  
  <script>
  import { GChart } from 'vue-google-charts'
  
  export default {
    components: { GChart },
  
    props: { data: Array },
  
    computed: {
      chartData() {
        return [
          ['Month', 'Profit'],
          ...(this.data || []).map(i => [
            i.month,
            Number(i.profit)
          ])
        ]
      }
    }
  }
  </script>